/* Built In Imports */
import { usePathname } from 'next/navigation';
import { forwardRef, useEffect, useState } from 'react';

/* External Imports */
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Icon,
  Image,
  Link,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
  Wrap,
  WrapItem,
  useMultiStyleConfig,
  useTab,
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import SingleLineText from '@components/UI/SingleLineText';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import config from '@config';
import EnlightenmentFiveRow from '@landing_pages/eoe/components/EnlightenmentFiveRow';
import EnlightenmentFourRow from '@landing_pages/eoe/components/EnlightenmentFourRow';
import EnlightenmentSixRow from '@landing_pages/eoe/components/EnlightenmentSixRow';
import LocationCard from '@landing_pages/eoe/components/LocationCard';
import FourCardsToronto from '@landing_pages/eoe/sections/FourCardsToronto';
import { refineUrlDomain } from '@components/Utility/utils';

/* Services */
import { getTicketList } from '@Services/eoeService';
import { searchByFieldId } from '@components/Utility/Shared/SharedService';
import { useEOEContext } from '@store/EOEContext';

/**
 *
 * @param {object} section
 * @returns ProgramDetailsEOE
 */
export const pageCss = {
  en: {
    tabTitle: {
      fontSize: {
        base: '16px',
        md: '22px',
      },
      color: 'red',
    },
    testimonialHeight: 571,
    cardTitle: {
      lineHeight: {
        base: '1.5rem',
        md: '1.6rem',
      },
    },
  },
};
let isViewGtmFired = false;
const ProgramDetailsEOE = ({ section, region, lang, pageData, setCityId }) => {
  const sectionContent = section?.sectionContent;
  const matchPath = usePathname();
  const isEoeCombinedPage = matchPath.endsWith('ecstasy-of-enlightenment');
  const isChennaiPage = matchPath.endsWith('sadhguru-in-chennai');

  const {
    isIeDone,
    setIsIeDone,
    ieLang,
    setIeLang,
    city,
    setCity,
    cityName,
    setCityName,
    country,
    setCountry,
    seatCategory,
  } = useEOEContext();

  const [isCatOpen, setCatIsOpen] = useState(false);
  const [isCityClicked, setIsCityClicked] = useState(false);
  const [selLang, setSelLang] = useState({ name: 'English', val: 'en' });

  const defaultTicketList = {
    tickets: [
      {
        id: 0,
        token: '',
        name: '',
        json_pricing: {
          base: {
            original_price: 0,
            price: 0,
          },
          english_price: {
            original_price: 0,
            price: 0,
          },
          vernacular_price: {
            original_price: 0,
            price: 0,
          },
        },
        seats_limited: true,
        seats_available: 0,
      },
      {
        id: 0,
        token: '',
        name: '',
        json_pricing: {
          base: {
            original_price: 0,
            price: 0,
          },
          english_price: {
            original_price: 0,
            price: 0,
          },
          vernacular_price: {
            original_price: 0,
            price: 0,
          },
        },
        seats_limited: true,
        seats_available: 0,
      },
      {
        id: 0,
        token: '',
        name: '',
        json_pricing: {
          base: {
            original_price: 0,
            price: 0,
          },
          english_price: {
            original_price: 0,
            price: 0,
          },
          vernacular_price: {
            original_price: 0,
            price: 0,
          },
        },
        seats_limited: true,
        seats_available: 0,
      },
      {
        id: 0,
        token: '',
        name: '',
        json_pricing: {
          base: {
            original_price: 0,
            price: 0,
          },
          english_price: {
            original_price: 0,
            price: 0,
          },
          vernacular_price: {
            original_price: 0,
            price: 0,
          },
        },
        seats_limited: true,
        seats_available: 0,
      },
      {
        id: 0,
        token: '',
        name: '',
        json_pricing: {
          base: {
            original_price: 0,
            price: 0,
          },
          english_price: {
            original_price: 0,
            price: 0,
          },
          vernacular_price: {
            original_price: 0,
            price: 0,
          },
        },
        seats_limited: true,
        seats_available: 0,
      },
    ],
  };
  const [listTicket, setListTicket] = useState(defaultTicketList);
  const isRestOfLocales =
    region !== 'us' && region !== 'uk' && region !== 'ca' && region !== 'in';

  useEffect(() => {
    if (pageData?.city) {
      setCity(pageData?.city);
      setCityName(pageData?.cityName);
    }
  }, [pageData.city, pageData?.cityName]);

  useEffect(() => {
    setCountry(pageData.country);
  }, [pageData.country]);
  // console.log('country',country);

  useEffect(() => {
    dataTicket(city);
    setCityId(city);
  }, [city]);

  useEffect(() => {
    if (typeof window !== undefined) {
      window.addEventListener('scroll', addViewGtm);
      return () => window.removeEventListener('scroll', addViewGtm);
    }
  }, []);

  useEffect(() => {
    let finalLang =
      isChennaiPage && !isIeDone
        ? lang === 'ta'
          ? { name: 'தமிழ்', val: 'ta' }
          : { name: 'Tamil', val: 'ta' }
        : { name: 'English', val: 'en' };
    setSelLang(finalLang);
    setIeLang(finalLang?.val);
    setCatIsOpen(false);
  }, [matchPath, isIeDone]);

  const addViewGtm = () => {
    if (!isViewGtmFired) {
      const completedIE = document?.getElementById('have-you-completed');
      const rect = completedIE?.getBoundingClientRect();
      const rectNum = Number(rect?.bottom?.toFixed());

      if (rectNum > 0 && rectNum < 180) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'view_item',
          ecommerce: {
            currency: '',
            value: '',
            items: [
              {
                item_id: '', // id of the program
                item_name:
                  pageData?.cityName?.toLowerCase() === 'chennai'
                    ? 'Sadhguruvudan Gyanam Dhyanam Anandham'
                    : 'Ecstasy of Enlightenment', // Name of the program (Ex - EoE)
                affiliation: '',
                coupon: '',
                discount: '',
                index: '',
                item_brand: '', //IE Status <Yes/No>
                item_category: '', //IE Lang (User selected IE Language Ex- MR,EN,HI)
                item_category2: '',
                item_category3: '',
                item_category4: '',
                item_category5: '',
                item_list_id: '',
                item_list_name: '',
                item_variant: '',
                location_id: '',
                price: '',
                quantity: '',
              },
            ],
          },
        });
        isViewGtmFired = true;
        setTimeout(() => {
          isViewGtmFired = false;
        }, 4000);
      }
    }
  };

  const dataTicket = async id => {
    try {
      if (id && !isNaN(parseInt(id))) {
        const res = await getTicketList(id);
        setListTicket(res.data);
      }
    } catch (error) {
      console.error('Err:', error);
    }
  };

  const CustomTab = forwardRef((props, ref) => {
    // 1. Reuse the `useTab` hook
    const tabProps = useTab({ ...props, ref });
    const isSelected = !!tabProps['aria-selected'];

    // 2. Hook into the Tabs `size`, `variant`, props
    const styles = useMultiStyleConfig('Tabs', tabProps);
    const Arrow = () => {
      return (
        <Box
          as="span"
          position="absolute"
          width="20px"
          display={isSelected ? 'block' : 'none'}
          height="11px"
          clipPath="polygon(0 0, 50% 100%, 100% 0)"
          left="50%"
          bottom="-10px"
          background="#FBAD2E"
          style={{ transition: 'width 1s' }}
          zIndex="0"
          transition="0.4s linear"
        ></Box>
      );
    };

    return (
      <Button
        __css={styles.tab}
        {...tabProps}
        width="50%"
        color={isSelected ? '#211637 !important' : '#7B7B7B  !important'}
        bg={isSelected ? '#FBAD2E' : '#E8DECB'}
        border="0"
        fontFamily="FedraSansStd-book"
        fontStyle="normal"
        fontWeight="600"
        fontSize={pageCss[lang]?.tabTitle?.fontSize}
        lineHeight="150.3%"
        _active={{ bg: '#FBAD2E', border: '0' }}
        _focus={{ bg: '#FBAD2E', border: '0' }}
        pos="relative"
        height={{ base: '45px', sm: '81px' }}
        p={{ base: '0', sm: '1rem' }}
      >
        {isSelected ? <Arrow /> : ''}

        {tabProps.children}
      </Button>
    );
  });

  const tabDesignHide =
    sectionContent[2]?.titleDecoration === 'tab-hide' ||
    sectionContent[8]?.titleDecoration === 'tab-hide';

  const cardInfo3 =
    sectionContent.find(el => el._modelApiKey === 'card_info3_column_group') ||
    '';

  return (
    <Box backgroundColor="#F1EBDF" pt={{ base: '20px', lg: '40px' }} minH={790}>
      {isEoeCombinedPage && (
        <>
          <SectionTitle titleObj={sectionContent[0]} mt="0" />
          <Flex
            justifyContent="center"
            alignItems="baseline"
            flexWrap="wrap"
            px={{ base: '20px', lg: '0' }}
          >
            {searchByFieldId(sectionContent, 'loc-dates') &&
              searchByFieldId(sectionContent, 'loc-dates-mob') && (
                <>
                  <Box
                    width={{ base: '100%', md: '42%' }}
                    display={{ base: 'none', md: 'block' }}
                  >
                    <StructuredTextParser
                      str={render(
                        searchByFieldId(sectionContent, 'loc-dates').body
                      )}
                      region={region}
                      lang={lang}
                      fontFamily="FedraSansStd-medium"
                      pb="20px"
                      textAlign="center"
                      className="loc-details"
                      color="#CF4520"
                      fontSize="20px"
                    />
                  </Box>
                  <Box
                    width={{ base: '100%', md: '42%' }}
                    display={{ base: 'block', md: 'none' }}
                  >
                    <StructuredTextParser
                      str={render(
                        searchByFieldId(sectionContent, 'loc-dates-mob').body
                      )}
                      region={region}
                      lang={lang}
                      fontFamily="FedraSansStd-medium"
                      pb="20px"
                      textAlign="center"
                      className="loc-details"
                      color="#CF4520"
                      fontSize="20px"
                    />
                  </Box>
                </>
              )}
          </Flex>
          <Flex
            justifyContent="center"
            alignItems="baseline"
            flexWrap="wrap"
            px={{ base: '20px', lg: '0px' }}
            mx="auto"
          >
            <Box width={{ base: '100%', sm: '22%', xl: '22%' }}>
              {sectionContent[1]?.text && (
                <Box display="flex" alignItems="center" gridGap="10px">
                  <LazyLoadImageComponent src="https://static.sadhguru.org/d/46272/1697477131-icon_calendar.svg" />
                  <SingleLineText
                    sectionContent={sectionContent[1]}
                    fontFamily="FedraSansStd-book"
                    my="10px"
                    color="#000"
                  />
                </Box>
              )}
              {sectionContent[2]?.text && (
                <Box display="flex" alignItems="center" gridGap="10px">
                  <LazyLoadImageComponent src="https://static.sadhguru.org/d/46272/1697477138-icon_clock_watch.svg" />
                  <SingleLineText
                    sectionContent={sectionContent[2]}
                    fontFamily="FedraSansStd-book"
                    my="10px"
                    color="#000"
                  />
                </Box>
              )}
            </Box>
            <Box width={{ base: '100%', sm: '22%', xl: '22%' }}>
              {sectionContent[3]?.text && (
                <Box display="flex" alignItems="center" gridGap="10px">
                  <LazyLoadImageComponent src="https://static.sadhguru.org/d/46272/1697477136-icon_translation.svg" />
                  <SingleLineText
                    sectionContent={sectionContent[3]}
                    my="10px"
                    fontFamily="FedraSansStd-book"
                    color="#000"
                  />
                </Box>
              )}
              {sectionContent[4]?.text && (
                <Box display="flex" alignItems="center" gridGap="10px">
                  <LazyLoadImageComponent src="https://static.sadhguru.org/d/46272/1697477134-icon_pin_location.svg" />
                  <SingleLineText
                    sectionContent={sectionContent[4]}
                    fontFamily="FedraSansStd-book"
                    my="10px"
                    color="#000"
                  />
                </Box>
              )}
            </Box>
          </Flex>
        </>
      )}
      {!isEoeCombinedPage && (
        <>
          <SectionTitle titleObj={sectionContent[0]} mt="0" />
          <Flex
            justifyContent="center"
            alignItems="baseline"
            flexWrap="wrap"
            px={{ base: '20px', lg: '0' }}
          >
            {searchByFieldId(sectionContent, 'loc-dates') &&
              searchByFieldId(sectionContent, 'loc-dates-mob') && (
                <>
                  <Box
                    width={{ base: '100%', md: '40%' }}
                    display={{ base: 'none', md: 'block' }}
                  >
                    <StructuredTextParser
                      str={render(
                        searchByFieldId(sectionContent, 'loc-dates').body
                      )}
                      region={region}
                      lang={lang}
                      fontFamily="FedraSansStd-medium"
                      pb="20px"
                      textAlign="center"
                      className="loc-details"
                      color="#CF4520"
                      fontSize="20px"
                    />
                  </Box>
                  <Box
                    width={{ base: '100%', md: '30%' }}
                    display={{ base: 'block', md: 'none' }}
                  >
                    <StructuredTextParser
                      str={render(
                        searchByFieldId(sectionContent, 'loc-dates-mob').body
                      )}
                      region={region}
                      lang={lang}
                      fontFamily="FedraSansStd-medium"
                      pb="20px"
                      textAlign="center"
                      className="loc-details"
                      color="#CF4520"
                      fontSize="20px"
                    />
                  </Box>
                </>
              )}
          </Flex>
          <Flex
            justifyContent="center"
            alignItems="baseline"
            flexWrap="wrap"
            px={{ base: '20px', lg: '0px' }}
            mx="auto"
          >
            <Box width={{ base: '100%', sm: '22%', xl: '22%' }}>
              {sectionContent[1]?.text && (
                <Box display="flex" alignItems="center" gridGap="10px">
                  <LazyLoadImageComponent src="https://static.sadhguru.org/d/46272/1697477131-icon_calendar.svg" />
                  <SingleLineText
                    sectionContent={sectionContent[1]}
                    fontFamily="FedraSansStd-book"
                    my="10px"
                    color="#000"
                  />
                </Box>
              )}
              {sectionContent[2]?.text && (
                <Box display="flex" alignItems="center" gridGap="10px">
                  <LazyLoadImageComponent src="https://static.sadhguru.org/d/46272/1697477138-icon_clock_watch.svg" />
                  <SingleLineText
                    sectionContent={sectionContent[2]}
                    fontFamily="FedraSansStd-book"
                    my="10px"
                    color="#000"
                  />
                </Box>
              )}
            </Box>
            <Box width={{ base: '100%', sm: '22%', xl: '22%' }}>
              {sectionContent[3]?.text && (
                <Box display="flex" alignItems="center" gridGap="10px">
                  <LazyLoadImageComponent src="https://static.sadhguru.org/d/46272/1697477136-icon_translation.svg" />
                  <SingleLineText
                    sectionContent={sectionContent[3]}
                    my="10px"
                    fontFamily="FedraSansStd-book"
                    color="#000"
                  />
                </Box>
              )}
              {sectionContent[4]?.text && (
                <Box display="flex" alignItems="center" gridGap="10px">
                  <LazyLoadImageComponent src="https://static.sadhguru.org/d/46272/1697477134-icon_pin_location.svg" />
                  <SingleLineText
                    sectionContent={sectionContent[4]}
                    fontFamily="FedraSansStd-book"
                    my="10px"
                    color="#000"
                  />
                </Box>
              )}
            </Box>
          </Flex>
        </>
      )}
      <Box
        background=" url(https://static.sadhguru.org/d/46272/1694600647-26-3.png) right center no-repeat"
        mt="70px"
      >
        <LazyLoadImageComponent
          width={{ base: '140px', md: '230px' }}
          src="https://static.sadhguru.org/d/46272/1694600647-26-3.png"
          alt="bg"
          position="absolute"
          transform="rotate(180deg)"
        />
        <SectionTitle titleObj={sectionContent[5]} />
        <Box
          display="flex"
          flexDir={{ base: 'column', md: 'row' }}
          maxW="850px"
          py={{ base: '15px', md: '60px' }}
          pt="0"
          px={{ base: '15px', md: 0 }}
          w="full"
          mx="auto"
          gridGap="30px"
          justifyContent="center"
        >
          <Box zIndex={3}>
            <LazyLoadImageComponent
              src={sectionContent[6].image?.url}
              alt={sectionContent[6].image?.alt}
            />
          </Box>
          <Box
            width={{ base: 'full', md: '375px' }}
            pt={{ base: '0', md: '40px' }}
          >
            {sectionContent[6]?.text && (
              <Box>
                <SingleLineText
                  sectionContent={sectionContent[6]}
                  fontSize="30px"
                  color="#02026C"
                  lineHeight="normal"
                  fontFamily="FedraSansStd-medium"
                  paddingTop="0"
                />
              </Box>
            )}
            <Box>
              {searchByFieldId(sectionContent, 'ie-contact-us') && (
                <>
                  <StructuredTextParser
                    str={render(
                      searchByFieldId(sectionContent, 'ie-contact-us').body
                    )}
                    region={region}
                    lang={lang}
                    fontSize="20px"
                    color="#000000"
                    fontFamily="FedraSansStd-book"
                    mt="0px"
                    className="linkText"
                  />
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box w="100%" maxW="1170px" mx="auto">
        {/* {pageData.country != 'IN' && country != 'IN' && ( */}
        {pageData.country != 'IN' && country != 'IN' || country != 'us' || country != 'ca' && (
          <Box maxW="494px" m="0 auto 30px auto">
            {searchByFieldId(sectionContent, 'oversease-link') && (
              <>
                <StructuredTextParser
                  str={render(
                    searchByFieldId(sectionContent, 'oversease-link').body
                  )}
                  region={region}
                  lang={lang}
                  color="#CF4520"
                  fontFamily="FedraSansStd-medium"
                  fontSize={{ base: '16px', md: '20px' }}
                  py="20px"
                  textAlign="center"
                  my="10px"
                  className="red-link"
                />
                <style>
                  {`
                  .red-link a {
                    text-decoration: underline;
                  }
                `}
                </style>
              </>
            )}
          </Box>
        )}
        {/* {(pageData.country === 'IN' || country === 'IN') && ( */}
        {/* {(region === 'in') && ( */}
        <Box maxW="494px" m="20px auto" id="have-you-completed">
          {searchByFieldId(sectionContent, 'completed-ie') && (
            <SingleLineText
              sectionContent={searchByFieldId(sectionContent, 'completed-ie')}
              fontSize={{ base: '24px', md: '30px' }}
              color="#02026C"
              lineHeight="normal"
              fontFamily="FedraSansStd-medium"
              paddingTop="0"
              textAlign="center"
            />
          )}
        </Box>
        
        {/* )} */}
        {/* {pageData.country && ( */}
        {/* {(region === 'in') && ( */}
        <Tabs
          isFitted
          variant="enclosed"
          p="0"
          className="tabcontent"
          border="none"
          borderRadius="12px"
          paddingBottom="20px"
          id="prgTab"
          defaultIndex={0}
        >
          {/* {!tabDesignHide && ( */}
          <TabList borderBottom="none">
            <CustomTab
              style={{ borderRadius: '10px 0 0 0' }}
              onClick={() => {
                setIsIeDone(true);
                if (sectionContent[9]?.titleSubtext) {
                  setCity(
                    config.ENV_NAME === 'production'
                      ? sectionContent[9]?.titleSubtext?.split('-')[1]
                      : sectionContent[9]?.titleSubtext?.split('-')[0]
                  );
                } else {
                  setCity(-1);
                }
                if (!pageData?.city) {
                  setListTicket(defaultTicketList);
                }
              }}
            >
              {sectionContent[9]?.titleText}
            </CustomTab>
            <CustomTab
              style={{ borderRadius: '0 10px 0 0' }}
              onClick={() => {
                setIsIeDone(false);
                if (sectionContent[18]?.titleSubtext) {
                  setCity(
                    config.ENV_NAME === 'production'
                      ? sectionContent[18]?.titleSubtext?.split('-')[1]
                      : sectionContent[18]?.titleSubtext?.split('-')[0]
                  );
                } else {
                  setCity(-1);
                }
                if (!pageData?.city) {
                  setListTicket(defaultTicketList);
                }
              }}
            >
              {sectionContent[18]?.titleText}
            </CustomTab>
          </TabList>
          {/* )} */}

          <TabPanels
            m="0 auto"
            bg="#fff"
            // borderRadius={
            //   pageData.country === 'IN' || country === 'IN'
            //     ? '0 0 15px 15px'
            //     : '15px'
            // }
            borderRadius="15px"
            mb="50px"
          >
            {/* Tab 1 starts here */}
            <TabPanel px={{ base: '15px', md: '0' }} pt="20px" pb="60px">
              {
                // (pageData.country === 'IN' || country === 'IN') &&
                searchByFieldId(sectionContent, 'red-msg-yes') && (
                  <>
                    <Box
                      color="#CF4520"
                      fontFamily="FedraSansStd-book"
                      fontSize="18px"
                      py={{ base: '20px', md: '40px' }}
                      px={{ base: '15px', md: '30px' }}
                      fontStyle="italic"
                      textAlign="center"
                      maxW="920px"
                      mx="auto"
                    >
                      {searchByFieldId(sectionContent, 'red-msg-yes').text}
                    </Box>
                    <Divider display={{ base: 'none', md: 'block' }} />
                  </>
                )
              }
              {searchByFieldId(sectionContent, 'yes-choose-city') && (
                <StructuredTextParser
                  str={render(
                    searchByFieldId(sectionContent, 'yes-choose-city').body
                  )}
                  region={region}
                  lang={lang}
                  color="#02026C"
                  fontFamily="FedraSansStd-medium"
                  fontSize={{ base: '18px', md: '20px' }}
                  py={{ base: '5px 10px', md: '20px' }}
                  textAlign="center"
                  m="10px auto"
                  maxW="80%"
                />
              )}
              {listTicket?.tickets?.length !== 3 && (
                <>
                  <LocationCard
                    sectionContent={
                      isRestOfLocales ? sectionContent[40] : sectionContent[14]
                    }
                    region={region}
                    lang={lang}
                    setIsCityClicked={setIsCityClicked}
                  />
                </>
              )}
              {/* // Combine page */}
              {isEoeCombinedPage && city !== -1 && (
                <>
                {!isNaN(parseInt(city)) && seatCategory && listTicket?.tickets?.length === 6 && (
                  <EnlightenmentSixRow
                    sectionContent={sectionContent}
                    region={region}
                    lang={lang}
                    pageData={pageData}
                    listTicket={listTicket}
                    setListTicket={setListTicket}
                    isCityClicked={city}
                    selTab="1"
                  />
                )}
                {!isNaN(parseInt(city)) && seatCategory && listTicket?.tickets?.length === 5 && (
                  <EnlightenmentFiveRow
                    sectionContent={sectionContent}
                    region={region}
                    lang={lang}
                    pageData={pageData}
                    listTicket={listTicket}
                    setListTicket={setListTicket}
                    isCityClicked={city}
                    selTab="1"
                  />
                )}
                {!isNaN(parseInt(city)) && seatCategory && listTicket?.tickets?.length === 4 && (
                  <EnlightenmentFourRow
                    sectionContent={sectionContent}
                    region={region}
                    lang={lang}
                    pageData={pageData}
                    listTicket={listTicket}
                    setListTicket={setListTicket}
                    isCityClicked={city}
                    selTab="1"
                  />
                )}
              </>
              )}
              {isNaN(parseInt(city)) && seatCategory && (
                <FourCardsToronto
                  section={section}
                  region={region}
                  lang={lang}
                  selTab="yes"
                />
              )}
              {isNaN(parseInt(city)) &&
                !isEoeCombinedPage ? seatCategory : !seatCategory &&
                listTicket?.tickets?.length === 6 && city !== null && (
                  <EnlightenmentSixRow
                    sectionContent={sectionContent}
                    region={region}
                    lang={lang}
                    pageData={pageData}
                    listTicket={listTicket}
                    setListTicket={setListTicket}
                    isCityClicked={isCityClicked}
                    selTab="yes"
                  />
                )}
              {isNaN(parseInt(city)) &&
                !isEoeCombinedPage ? seatCategory : !seatCategory &&
                listTicket?.tickets?.length === 5 && city !== null && (
                  <EnlightenmentFiveRow
                    sectionContent={sectionContent}
                    region={region}
                    lang={lang}
                    pageData={pageData}
                    listTicket={listTicket}
                    setListTicket={setListTicket}
                    isCityClicked={isCityClicked}
                    selTab="2"
                  />
                )}
              {isNaN(parseInt(city)) &&
                !isEoeCombinedPage ? seatCategory : !seatCategory &&
                listTicket?.tickets?.length === 4 && city !== null && (
                  <EnlightenmentFourRow
                    sectionContent={sectionContent}
                    region={region}
                    lang={lang}
                    pageData={pageData}
                    listTicket={listTicket}
                    setListTicket={setListTicket}
                    isCityClicked={isCityClicked}
                    selTab="2"
                  />
                )}
              {(isCityClicked || city) &&
                isNaN(parseInt(city)) &&
                !seatCategory &&
                searchByFieldId(sectionContent, 'reg-soon') && (
                  <>
                  <StructuredTextParser
                    str={render(
                      searchByFieldId(sectionContent, 'reg-soon').body
                    )}
                    region={region}
                    lang={lang}
                    color="#CF4520"
                    fontFamily="FedraSansStd-medium"
                    fontSize={{ base: '16px', md: '20px' }}
                    py="20px"
                    textAlign="center"
                    my="10px"
                    className="red-link"
                  />
                  </>
                )}
                {/* {isNaN(parseInt(city)) && isCityClicked && (
                  <Box display="flex" placeContent="center">
                  <Link
                    href={refineUrlDomain(sectionContent[42]?.linkUrl,
                      region,
                      lang
                    )}
                    mb="20px"
                    display="block"
                    fontWeight={'500'}
                    fontFamily={'FedraSansStd-medium'}
                    fontSize={'18px'}
                    bgColor={'#cf4520'}
                    h={'auto'}
                    minH="50px"
                    textAlign="left"
                    padding={'14px 29px'}
                    borderRadius="5px"
                    color="#faf7f0"
                    textDecoration="none"
                    width={'auto'}
                    cursor={'pointer'}
                    _hover={{
                      bg: '#000054',
                    }}
                    // target={'_blank'}
                    // onClick={() => {
                    //   gtmClick();
                    // }}
                  >
                    {sectionContent[42]?.buttonText}
                  </Link>
                  </Box>
                )} */}
            </TabPanel>

            {/* Tab 2 starts here NO */}
            <TabPanel px={{ base: '15px', md: '0' }} pt="30px" pb="30px">
              {searchByFieldId(sectionContent, 'red-msg-no') && (
                <Box
                  color="#CF4520"
                  fontFamily="FedraSansStd-book"
                  fontSize="20px"
                  pt={{ base: '15px', md: '15px' }}
                  pb="10px"
                  px={{ base: '15px', md: '15px' }}
                  fontStyle="italic"
                  textAlign="center"
                  maxW="740px"
                  mx="auto"
                >
                  {searchByFieldId(sectionContent, 'red-msg-no').text}
                </Box>
              )}
              {searchByFieldId(sectionContent, 'no-text-1') && region == 'in' && country === 'IN' && (
                <Box
                  fontFamily="FedraSansStd-book"
                  fontSize="16px"
                  pt={{ base: '15px', md: '15px' }}
                  pb="10px"
                  px={{ base: '15px', md: '15px' }}
                  fontStyle="italic"
                  textAlign="center"
                  maxW="760px"
                  mx="auto"
                >
                  <StructuredTextParser
                    str={render(
                      searchByFieldId(sectionContent, 'no-text-1').body
                    )}
                    region={region}
                    lang={lang}
                    fontFamily="FedraSansStd-book"
                    textAlign="center"
                    pb="20px"
                    px={{ base: '1%', xl: '7%' }}
                    mt="0px"
                  />
                </Box>
                )}
              {/* {searchByFieldId(sectionContent, 'no-sel-lang-text') && (
                  <StructuredTextParser
                    str={render(
                      searchByFieldId(sectionContent, 'no-sel-lang-text').body
                    )}
                    region={region}
                    lang={lang}
                    fontFamily="FedraSansStd-medium"
                    textAlign="center"
                    pb="5px"
                    fontSize="24px"
                    color="#303030"
                    mt="0px"
                  />
                )} */}
              {searchByFieldId(sectionContent, 'sel-lang-below-lis')?.text && (
                <Box
                  color="#000000"
                  fontFamily="FedraSansStd-book"
                  fontSize="16px"
                  py="20px"
                  textAlign="center"
                  pb="20px"
                  px={{ base: '20px', md: '10%', lg: '25%' }}
                >
                  {searchByFieldId(sectionContent, 'sel-lang-below-list') && (
                    <SingleLineText
                      sectionContent={searchByFieldId(
                        sectionContent,
                        'sel-lang-below-list'
                      )}
                      fontFamily="FedraSansStd-book"
                      m="0 auto"
                      color="#000"
                      display={{ base: 'none', md: 'block' }}
                      fontSize={{ base: '14px', md: '14px' }}
                      maxW="320px"
                      my="0"
                      mb="20px"
                      textAlign="center"
                    />
                  )}
                </Box>
              )}
              {searchByFieldId(sectionContent, 'yes-choose-city') &&
                render(
                  searchByFieldId(sectionContent, 'yes-choose-city').body
                ) !== '<p></p>' && (
                  <StructuredTextParser
                    str={render(
                      searchByFieldId(sectionContent, 'yes-choose-city').body
                    )}
                    region={region}
                    lang={lang}
                    color="#02026C"
                    fontFamily="FedraSansStd-medium"
                    fontSize={{ base: '18px', md: '20px' }}
                    py={{ base: '10px', md: '20px' }}
                    textAlign="center"
                    m="10px auto"
                    maxW="80%"
                  />
                )}
              {listTicket?.tickets?.length !== 3 && (
                  <LocationCard
                    sectionContent={
                      isRestOfLocales ? sectionContent[41] : sectionContent[24]
                    }
                    region={region}
                    lang={lang}
                    setIsCityClicked={setIsCityClicked}
                  />
              )}
              {isNaN(parseInt(city)) && seatCategory && (
                <FourCardsToronto
                  section={section}
                  region={region}
                  lang={lang}
                  selTab="no"
                />
              )}
              {country != 'IN' && city !== -1 && seatCategory != 'Toronto' && (
                <>
                <Center maxW={1170} m="50px auto 100px" w="100%">
                  <Wrap
                    w="100%"
                    alignItems="center"
                    justifyContent="center"
                    maxW={{ base: 200, md: '100%', lg: 1070 }}
                    justify="center"
                  >
                    {cardInfo3?.cards?.map((card, index) => {
                      return (
                        <WrapItem>
                          <VStack my="20px">
                            <Flex w="full" justify="center">
                              <Center
                                rounded="full"
                                w="160px"
                                h="160px"
                                bg="#FFF5E3"
                                mx={{
                                  base: '10px',
                                  md: '20px',
                                  lg: '30px',
                                }}
                              >
                                <Image
                                  src={card?.thumbnail?.url}
                                  alt={card?.thumbnail?.alt || ''}
                                  w={{ base: '80px', lg: '100px' }}
                                />
                              </Center>
                              {index !== cardInfo3.cards.length - 1 && (
                                <Flex
                                  mx={{ md: '0px', lg: '-20px' }}
                                  align="center"
                                  justify="center"
                                  display={{ base: 'none', md: 'flex' }}
                                >
                                  <Icon
                                    width="30px"
                                    height="30px"
                                    viewBox="0 0 30px 30px"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M26.7852 14.6668L17.3654 24.0867L15.6369 22.3582L22.106 15.8891L4.2789 15.8891V13.4446L22.106 13.4446L15.6369 6.97556L17.3654 5.24707L26.7852 14.6668Z"
                                      fill="#343434"
                                    />
                                  </Icon>
                                </Flex>
                              )}
                            </Flex>
                            <StructuredTextParser
                              str={render(card?.description?.value)}
                              textAlign="center"
                              w="210px"
                              fontFamily="'FedraSansStd-book'"
                              fontSize="20px"
                              className="alink"
                            />
                            {index !== cardInfo3.cards.length - 1 && (
                              <Flex
                                align="center"
                                justify="center"
                                display={{ base: 'flex', md: 'none' }}
                              >
                                <Icon
                                  width="30px"
                                  height="30px"
                                  viewBox="0 0 30px 30px"
                                  fill="none"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M15.3341 26.7842L5.91431 17.3644L7.6428 15.6359L14.1119 22.105L14.1119 4.27792L16.5564 4.27792L16.5564 22.105L23.0254 15.6359L24.7539 17.3644L15.3341 26.7842Z"
                                    fill="#343434"
                                  />
                                </Icon>
                              </Flex>
                            )}
                          </VStack>
                        </WrapItem>
                      );
                    })}
                  </Wrap>
                </Center>
                </>
              )}
              {/* {pageData.country === 'IN' && !isNaN(parseInt(city)) && (
                <> */}
              {pageData.country === 'IN' && searchByFieldId(sectionContent, 'no-sel-lang-text') && seatCategory !== 'Toronto' && (
                <>
                  <StructuredTextParser
                    str={render(
                      searchByFieldId(sectionContent, 'no-sel-lang-text')
                        .body
                    )}
                    region={region}
                    lang={lang}
                    fontFamily="FedraSansStd-medium"
                    textAlign="center"
                    pb="19px"
                    fontSize="24px"
                    color="#303030"
                    mt="20px"
                  />
                  <Flex alignItems="center" justifyContent="center">
                    <Button
                      bg="transparent"
                      value={'English'}
                      fontSize={{ base: '16px', md: '18px' }}
                      variant="link"
                      maxW="157px"
                      mx="auto"
                      border="2px solid #CF4520 !important"
                      mb="60px"
                      h="42px"
                      color="#CF4520"
                      fontFamily="FedraSansStd-medium"
                      fontWeight={350}
                      display="inline-flex"
                      _hover={{
                        border: '0px solid #B7987E',
                        background: '#a534151a',
                      }}
                      _focus={{ border: '0px solid #B7987E' }}
                      _active={{
                        border: '0px solid #B7987E',
                        background: '#a534151a',
                      }}
                      rightIcon={
                        isCatOpen ? (
                          <ChevronUpIcon fontSize="30px" />
                        ) : (
                          <ChevronDownIcon fontSize="30px" />
                        )
                      }
                      onClick={() => setCatIsOpen(!isCatOpen)}
                      className="selectButton"
                      textTransform="capitalize"
                      justifyContent="center"
                      w="157px"
                    >
                      <Text
                        whiteSpace="nowrap"
                        overflow="hidden"
                        textOverflow="ellipsis"
                        p="10px 5px"
                        _hover={{ color: '#BC570F' }}
                        w="auto"
                      >
                        {selLang?.name}
                      </Text>
                      {isCatOpen && (
                        <Flex
                          whiteSpace="break-spaces"
                          className="options"
                          alignItems="flex-start"
                          alignContent="flex-start"
                          position="absolute"
                          top={{ base: '45px', md: '47px' }}
                          zIndex="100"
                          left="0"
                          boxShadow="0px 0.75926px 2.36111px 0px rgba(0, 0, 0, 0.03), 0px 3.34074px 4.88889px 0px rgba(0, 0, 0, 0.05), 0px 8.2px 9.75px 0px rgba(0, 0, 0, 0.06), 0px 15.79259px 19.11111px 0px rgba(0, 0, 0, 0.07), 0px 26.57407px 35.13889px 0px rgba(0, 0, 0, 0.09), 0px 41px 60px 0px rgba(0, 0, 0, 0.12)"
                          w={{ base: '103px', md: '116px' }}
                          flexDir="column"
                          bg="#ffffff"
                          mt={{ base: '0', md: '0' }}
                          p={{ base: '10px 15px', md: '10px 15px' }}
                          minW="157px"
                          border="1px solid #E6E6E6"
                          borderRadius="5px"
                        >
                          {Object?.keys(
                            sectionContent[22]?.data ||
                              sectionContent[24]?.data
                          ).map((item, val) => {
                            const secCon = sectionContent[22]?.data
                              ? sectionContent[22]
                              : sectionContent[24];
                            return (
                              secCon?.data[item].name !== selLang?.name && (
                                <Box
                                  padding="8px 0px"
                                  cursor="pointer"
                                  m="0 auto"
                                  onClick={() => {
                                    setSelLang(secCon?.data[item]);
                                    setIeLang(secCon?.data[item].val);
                                  }}
                                >
                                  <Text textAlign="left" fontFamily="">
                                    <Link
                                      color="#6D6358"
                                      textAlign="left"
                                      _hover={{
                                        color: '#BC570F',
                                        fontWeight: '400',
                                        textAlign: 'left',
                                      }}
                                      _active={{
                                        color: '#BC570F',
                                        fontWeight: '400',
                                        textAlign: 'left',
                                      }}
                                      _focus={{
                                        color: '#BC570F',
                                        fontWeight: '400',
                                        textAlign: 'left',
                                      }}
                                    >
                                      {secCon?.data[item].name}
                                    </Link>
                                  </Text>
                                </Box>
                              )
                            );
                          })}
                        </Flex>
                      )}
                    </Button>
                  </Flex>
                </>
              )}

              {isEoeCombinedPage && pageData.country === 'IN' && city !== -1 && seatCategory != 'Toronto' && (<>
                {listTicket?.tickets?.length === 6 && (
                  <EnlightenmentSixRow
                    sectionContent={sectionContent}
                    region={region}
                    lang={lang}
                    pageData={pageData}
                    listTicket={listTicket}
                    setListTicket={setListTicket}
                    isCityClicked={city}
                    selTab="4"
                  />
                )}
                {listTicket?.tickets?.length === 5 && (
                  <EnlightenmentFiveRow
                    sectionContent={sectionContent}
                    region={region}
                    lang={lang}
                    pageData={pageData}
                    listTicket={listTicket}
                    setListTicket={setListTicket}
                    isCityClicked={city}
                    selTab="4"
                  />
                )}
                {listTicket?.tickets?.length === 4 && (
                  <EnlightenmentFourRow
                    sectionContent={sectionContent}
                    region={region}
                    lang={lang}
                    pageData={pageData}
                    listTicket={listTicket}
                    setListTicket={setListTicket}
                    isCityClicked={city}
                    selTab="4"
                  />
                )}
                </>
              )}

              {!isEoeCombinedPage && country === 'IN' && city !== -1 && (<>
                {isNaN(parseInt(city)) && !isEoeCombinedPage ? seatCategory : !seatCategory &&
                  listTicket?.tickets?.length === 6 && (
                    <EnlightenmentSixRow
                      sectionContent={sectionContent}
                      region={region}
                      lang={lang}
                      pageData={pageData}
                      listTicket={listTicket}
                      setListTicket={setListTicket}
                      isCityClicked={isCityClicked}
                      selTab="5"
                    />
                  )}
                {isNaN(parseInt(city)) && !isEoeCombinedPage ? seatCategory : !seatCategory &&
                  listTicket?.tickets?.length === 5 && listTicket?.tickets[0].id !== 0 && (
                    <EnlightenmentFiveRow
                      sectionContent={sectionContent}
                      region={region}
                      lang={lang}
                      pageData={pageData}
                      listTicket={listTicket}
                      setListTicket={setListTicket}
                      isCityClicked={isCityClicked}
                      selTab="5"
                      selCity={parseInt(city)}
                    />
                  )}
                  {isNaN(parseInt(city)) && !isEoeCombinedPage ? seatCategory : !seatCategory &&
                  listTicket?.tickets?.length === 4 && listTicket?.tickets[0].id !== 0 && (
                    <EnlightenmentFourRow
                      sectionContent={sectionContent}
                      region={region}
                      lang={lang}
                      pageData={pageData}
                      listTicket={listTicket}
                      setListTicket={setListTicket}
                      isCityClicked={isCityClicked}
                      selTab="5"
                    />
                  )}
                </>
              )}
              {/* {isCityClicked &&
                isNaN(parseInt(city)) &&
                !seatCategory &&
                searchByFieldId(sectionContent, 'reg-soon') && (
                  <>
                  <StructuredTextParser
                    str={render(
                      searchByFieldId(sectionContent, 'reg-soon').body
                    )}
                    region={region}
                    lang={lang}
                    color="#CF4520"
                    fontFamily="FedraSansStd-medium"
                    fontSize={{ base: '16px', md: '20px' }}
                    py="20px"
                    textAlign="center"
                    my="10px"
                    className="red-link"
                  />
                  </>
                )}
                {isNaN(parseInt(city)) && isCityClicked && (
                  <Box display="flex" placeContent="center">
                  <Link
                    href={refineUrlDomain(sectionContent[42]?.linkUrl,
                      region,
                      lang
                    )}
                    mb="20px"
                    display="block"
                    fontWeight={'500'}
                    fontFamily={'FedraSansStd-medium'}
                    fontSize={'18px'}
                    bgColor={'#cf4520'}
                    h={'auto'}
                    minH="50px"
                    textAlign="left"
                    padding={'14px 29px'}
                    borderRadius="5px"
                    color="#faf7f0"
                    textDecoration="none"
                    width={'auto'}
                    cursor={'pointer'}
                    _hover={{
                      bg: '#000054',
                    }}
                    // target={'_blank'}
                    // onClick={() => {
                    //   gtmClick();
                    // }}
                  >
                    {sectionContent[42]?.buttonText}
                  </Link>
                  </Box>
                )} */}
            </TabPanel>
          </TabPanels>
        </Tabs>
        {/* )} */}
      </Box>
      <br/>
      <style jsx global>
        {`
          .alink a mark,
          .alink p mark {
            background: none;
          }
          .alink a mark {
            color: #cf4520;
          }
          .pStrong p strong {
            display: block;
          }
          .textParagraph p {
            font-size: 18px;
            color: #be3a1d;
            text-transform: uppercase;
          }
          .textParagraph p:nth-child(2) {
            font-size: 16px;
            color: #28231e;
            text-transform: none;
            font-family: 'FedraSansStd-book';
          }
          .linkText p a {
            text-decoration: underline;
          }
          .loc-details {
            font-family: "FedraSansStd-book"
          }
          .loc-details strong, .loc-details mark {
            color: black;
            font-family:"FedraSansStd-medium";
            font-weight:500
          }
          .loc-details mark {
            color: #CF4520;
            background: none;
          }
          .loc-details a {
            text-decoration: underline;
          }  
          @media only screen and (max-width: 360px) {
            .gridComponent {
              grid-template-columns: repeat(1, minmax(0, 1fr));
              margin-top: 10px;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default ProgramDetailsEOE;